<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <img src="/assets/logos/lgsxxl-logo.png" alt="" />
      <h3 v-if="this.$route.query.sso && !error">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</h3>
      <SsoError v-if="error" :message="error"></SsoError>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  name: "LGSXXLarge",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      secretKey: 'VswFYGzh2k45N7Q8R9@TBuCVexFY.G2J3K4N6p7Q%9SATB-VdWeXFZHJ3m5N',
      boostifyEduUrl: 'https://www.boostifyedu.com/sso/ues',
      userData: null,
      userData2: null,
      error: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.sso) {
      this.loading = true
      // gelen data çözülüyor
      const decode = decodeURIComponent(atob(query.sso));
      const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(bytes);
      this.ueslmsCheckUser();
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('LGS XXLarge SSO:', message);
    },

    ueslmsCheckUser() {
      axios.post('https://www.ueslms.com/api/v2/lgsxxlarge/user/check', {user: this.userData})
      // axios.post('https://ueslms.test/api/v2/lgsxxlarge/user/check', {user: this.userData})
          .then(response => {
            if (response.data.success) {
              this.userData2 = response.data.user;
              this.goLGSXXLarge(response.data.token)
            } else if (response.data.message) {
              // success:false + message → örn. lisans/yetki reddi. Kullanıcı henüz
              // yok diye create'e düşmek yerine reddi doğrudan gösteriyoruz, çünkü
              // create de aynı kontrolden geçip aynı sebeple reddedilecek.
              this.fail(response.data.message)
            } else {
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      axios.post('https://www.ueslms.com/api/v2/lgsxxlarge/user/create', this.userData)
      // axios.post('https://ueslms.test/api/v2/lgsxxlarge/user/create', this.userData)
          .then(response => {
            if (response.data.success) {
              this.userData2 = response.data.user;
              this.goLGSXXLarge(response.data.token)
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    // LGS XXLarge artık BoostifyEdu (BE) içinde; öğrenci ve öğretmen BE'ye gider.
    // UES sorguları lgsxxlarge uç noktalarında kalır (lisans kontrolü 'lgsxxlarge' ile).
    // Token (BoostifyEdu.vue ile aynı format + product: 'lgsxxlarge') ueslms tarafından üretilir:
    // LGSXXLargeController → BoostifyEduSsoTokenService. Eskiden burada tarayıcıda CryptoJS ile
    // üretiliyordu ve anahtar JS bundle'ında açık duruyordu.
    goLGSXXLarge(token) {
      if (!token) {
        // Sunucuda BOOSTIFYEDU_SSO_SECRET tanımlı değilse token gelmez (ueslms log'a hata yazar)
        this.fail('Giriş anahtarı oluşturulamadı. Lütfen okulunuzla iletişime geçiniz.');
        return;
      }
      window.location.href = this.boostifyEduUrl + '?token=' + token;
    },

  }
}
</script>
